"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrumbsFullPage = exports.BoardCrumbs = exports.BoardCrumbsWithRefreshLine = exports.CrumbsNoRefresh = exports.CrumbsWithRefresh = exports.CrumbsWithRefreshLine = exports.Crumbs = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
var react_router_dom_1 = require("react-router-dom");
var refresh_1 = require("../refresh");
var swr_1 = __importDefault(require("swr"));
var web_1 = require("../../config/web");
var sidemenu_1 = require("../../modules/data/sidemenu");
function Crumbs() {
    var _this = this;
    var location = (0, react_router_dom_1.useLocation)();
    var _a = (0, react_1.useState)(null), pathlist = _a[0], SetPathList = _a[1];
    (0, react_1.useEffect)(function () {
        ;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var config, pathname, hash;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, sidemenu_1.getSidemenuData)()];
                    case 1:
                        config = _a.sent();
                        pathname = location.pathname;
                        hash = location.hash;
                        SetPathList(findPathStr(config.sidemenu, pathname, hash));
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [location]);
    return (react_1.default.createElement("div", { className: "crumbs" },
        react_1.default.createElement("a", { href: "https://www.eastmoney.com/" }, "\u4E1C\u65B9\u8D22\u5BCC\u7F51"),
        " > ",
        react_1.default.createElement(react_router_dom_1.Link, { to: "./" }, "\u884C\u60C5\u4E2D\u5FC3"), pathlist === null || pathlist === void 0 ? void 0 :
        pathlist.filter(function (v) { return v.path != undefined || v.link != undefined; }).map(function (v, index) {
            return react_1.default.createElement(react_1.default.Fragment, { key: index },
                " > ",
                react_1.default.createElement(react_1.default.Fragment, null, " "),
                (location.pathname + location.hash) == web_1.routerPrefix + v.path ?
                    react_1.default.createElement(react_1.default.Fragment, null, v.title)
                    :
                        v.link ? react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("a", { href: v.link, target: "_blank" },
                                react_1.default.createElement(react_1.default.Fragment, null, v.title)))
                            :
                                react_1.default.createElement(react_router_dom_1.Link, { to: web_1.routerPrefix + v.path }, v.title));
        })));
}
exports.Crumbs = Crumbs;
/** 查找菜单路径 */
function findPathStr(config, pathname, hash, retainPrefix) {
    var path = pathname + hash;
    var result = null;
    /** 保留center前缀 */
    if (retainPrefix) {
    }
    else {
        path = path.replace(/^\/center\//, "/").replace(/^\/center2\//, "/"); // 路由带center 前缀（不包括全屏情况）
    }
    config.forEach(function (v, index) {
        var vpath = v.path;
        if (v.path && v.path.indexOf('#') == 0) {
            vpath = '/gridlist.html' + v.path;
        }
        if (v.sub) {
            var findsub = findPathStr(v.sub, pathname, hash, retainPrefix);
            if (findsub) {
                result = [{
                        title: v.title,
                        path: vpath,
                        link: v.link
                    }].concat(findsub);
            }
            else if (vpath == path) {
                result = [{
                        title: v.title,
                        path: vpath,
                        link: v.link
                    }];
            }
        }
        else if (vpath == path || v.link == path) {
            result = [{
                    title: v.title,
                    path: vpath,
                    link: v.link
                }];
        }
    });
    return result;
}
/**
 * 带刷新按钮带下划线的面包屑
 */
function CrumbsWithRefreshLine(props) {
    return (react_1.default.createElement("div", { className: "cwrl scf" },
        react_1.default.createElement("div", { className: "l" },
            react_1.default.createElement(Crumbs, null)),
        react_1.default.createElement("div", { className: "r" },
            props.insertRight && props.insertRight,
            !props.hideFresh && react_1.default.createElement(refresh_1.RefreshBtn, null))));
}
exports.CrumbsWithRefreshLine = CrumbsWithRefreshLine;
/**
 * 带刷新按钮的面包屑
 */
function CrumbsWithRefresh() {
    return (react_1.default.createElement("div", { className: "cwrl2 scf" },
        react_1.default.createElement("div", { className: "l" },
            react_1.default.createElement(Crumbs, null)),
        react_1.default.createElement("div", { className: "r" },
            react_1.default.createElement(refresh_1.RefreshBtn, null))));
}
exports.CrumbsWithRefresh = CrumbsWithRefresh;
/**
 * 不带刷新按钮的面包屑
 */
function CrumbsNoRefresh(props) {
    return (react_1.default.createElement("div", { className: "cwrl2 scf" },
        react_1.default.createElement("div", { className: "l" },
            react_1.default.createElement(Crumbs, null)),
        react_1.default.createElement("div", { className: "r" }, props.insertRight && props.insertRight)));
}
exports.CrumbsNoRefresh = CrumbsNoRefresh;
/**
 * 板块带刷新按钮带下划线的面包屑
 */
function BoardCrumbsWithRefreshLine(props) {
    return (react_1.default.createElement("div", { className: "cwrl scf" },
        react_1.default.createElement("div", { className: "l" },
            react_1.default.createElement(BoardCrumbs, { bkname: props.bkname })),
        react_1.default.createElement("div", { className: "r" },
            props.insertRight && props.insertRight,
            react_1.default.createElement(refresh_1.RefreshBtn, null))));
}
exports.BoardCrumbsWithRefreshLine = BoardCrumbsWithRefreshLine;
/**
 * 板块面包屑
 * @returns
 */
function BoardCrumbs(props) {
    var _a;
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash;
    var bkcode = hash.split("-")[1];
    /** 获取配置 */
    var _b = (0, swr_1.default)("all_bk_info", function () { return (0, sidemenu_1.getSidemenuData)(); }, {
        revalidateOnFocus: false
    }), data = _b.data, error = _b.error;
    if (!data)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var current = ((_a = data.bklist) === null || _a === void 0 ? void 0 : _a.filter(function (v) { return v.code == bkcode.split('.')[1]; })) || {};
    if (current.length < 1)
        return react_1.default.createElement(react_1.default.Fragment, null);
    var preName = "", preHash = "";
    switch (current[0].type) {
        case 3:
            preName = '概念板块';
            preHash = "concept_board";
            break;
        case 1:
            preName = '地域板块';
            preHash = "region_board";
            break;
        case 2:
            preName = '行业板块';
            preHash = "industry_board";
            break;
    }
    var hypreName = "", hypreHash = "";
    if (current[0].type == 2) {
        switch (current[0].flag) {
            case 1:
                hypreName = '东财一级行业';
                hypreHash = "industry_board_1";
                break;
            case 2:
                hypreName = '东财二级行业';
                hypreHash = "industry_board_2";
                break;
            case 3:
                hypreName = '东财三级行业';
                hypreHash = "industry_board_3";
                break;
        }
    }
    return (react_1.default.createElement("div", { className: "crumbs" },
        react_1.default.createElement("a", { href: "https://www.eastmoney.com/" }, "\u4E1C\u65B9\u8D22\u5BCC\u7F51"),
        " > ",
        react_1.default.createElement(react_router_dom_1.Link, { to: "./" }, "\u884C\u60C5\u4E2D\u5FC3"),
        " > ",
        react_1.default.createElement(react_router_dom_1.Link, { to: "hsbk.html" }, " \u6CAA\u6DF1\u4EAC\u677F\u5757"),
        " > ",
        react_1.default.createElement(react_router_dom_1.Link, { to: "gridlist.html#".concat(preHash) }, preName),
        " >",
        ' ',
        hypreName && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_router_dom_1.Link, { to: "gridlist.html#".concat(hypreHash) }, hypreName),
            " > "),
        react_1.default.createElement("span", null, props.bkname)));
}
exports.BoardCrumbs = BoardCrumbs;
/**
 * 全屏面包屑
 * @returns
 */
function CrumbsFullPage() {
    var _this = this;
    var location = (0, react_router_dom_1.useLocation)();
    var _a = (0, react_1.useState)(null), pathlist = _a[0], SetPathList = _a[1];
    (0, react_1.useEffect)(function () {
        ;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var config, hash, pathinfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, sidemenu_1.getSidemenuData)()];
                    case 1:
                        config = _a.sent();
                        hash = location.hash;
                        pathinfo = findPathStr(config.sidemenu, location.pathname, hash, true);
                        // console.log(pathinfo)
                        SetPathList(pathinfo);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [location]);
    return (react_1.default.createElement("div", { className: "crumbs" },
        react_1.default.createElement("a", { href: "https://www.eastmoney.com/" }, "\u4E1C\u65B9\u8D22\u5BCC\u7F51"),
        " > ",
        react_1.default.createElement("a", { href: "./", target: "_self" }, "\u884C\u60C5\u4E2D\u5FC3"), pathlist === null || pathlist === void 0 ? void 0 :
        pathlist.map(function (v, index) {
            return react_1.default.createElement(react_1.default.Fragment, { key: index },
                " > ",
                react_1.default.createElement(react_1.default.Fragment, null, " "),
                ((location.pathname + location.hash) == v.path || (location.pathname + location.hash) == v.link) ?
                    react_1.default.createElement(react_1.default.Fragment, null, v.title)
                    :
                        react_1.default.createElement("a", { href: web_1.routerPrefix + v.path, target: "_self" }, v.title));
        })));
}
exports.CrumbsFullPage = CrumbsFullPage;
